import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FinfraStepperModule } from "@atumverse/app-core-components";
import { TranslateModule } from "@atumverse/core-decorators";
import { FunctionComponent } from "./function.component";

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,

    TranslateModule,
    FinfraStepperModule

  ],
  declarations: [FunctionComponent],
  exports: [FunctionComponent]
})
export class FunctionModule { }
